"use strict";

import Dom from "common/Dom";
import slickCarousel from "slick-carousel";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  handlers.initSliders();
};
